import styled from "styled-components/macro";
import { calculateRem } from "styles/mixins/calculateRem";

export const StyledUserScheduledTests = styled.div`
  margin-right: ${calculateRem(32)};
  width: 100%;
`;
